import { render, staticRenderFns } from "./home_project6.vue?vue&type=template&id=b8b2b3ea&scoped=true&"
import script from "./home_project6.vue?vue&type=script&lang=js&"
export * from "./home_project6.vue?vue&type=script&lang=js&"
import style0 from "./home_project6.vue?vue&type=style&index=0&id=b8b2b3ea&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b8b2b3ea",
  null
  
)

export default component.exports